export const HEADER_BLOCK_S01 = {
  "blockType": "HEADER",
  "blockDesign": "HeaderDesign2",
  "editFormName": "HEADER_04_FORM",
  "styleProps": {
    "background-image": "url('')",
    "background-color": "#ffffff",
    "padding": "120px 20px 120px 20px"
  },
  "textBlock": {
    "styleProps": {
      "background-color": "",
      "border-radius": "0",
      "padding": "10px 10px 10px 10px"
    },
    "stylePropsTab": {},
    "stylePropsMob": {},
    "alingBlock": "center",
    "headings": [
      {
        "text": "Transforming Businesses with Innovative Software Solutions",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "red",
          "height": "4px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "3.75rem",
          "line-height": "1",
          "font-weight": "400",
          "font-family-cust": "Source Serif 4",
          "font-family": "'Source Serif 4'",
          "font-family-bk": "'Source Serif 4', cursive"
        },
        "alignStyleProps": {
          "text-align": "left",
          "margin": "10px 0px 40px 0px",
          "padding": "10px 20px 10px 20px"
        },
        "stylePropsMob": {
          "font-size": "2.25rem",
          "line-height": "2.5rem"
        },
        "stylePropsTab": {
          "font-size": "3.75rem",
          "line-height": "1"
        }
      },
      {
        "text": "Empowering growth, efficiency, and success through cutting-edge technology",
        "hideUnderline": false,
        "underLineStyle": {
          "background-color": "yellow",
          "height": "2px"
        },
        "styleProps": {
          "color": "#333333",
          "font-size": "1.5rem",
          "line-height": "2rem"
        },
        "alignStyleProps": {
          "text-align": "left",
          "padding": "0px 20px 0px 20px"
        },
        "stylePropsMob": {
          "font-size": "1.25rem",
          "line-height": "1.75rem"
        }
      }
    ],
    "dynamicText": {
      "styleProps": {
        "color": "#ffffff",
        "font-size": "1.875rem",
        "line-height": "2.25rem",
        "padding": "10px 0px 10px 0px",
        "text-align": "center"
      },
      "stylePropsTab": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "stylePropsMob": {
        "padding": "10px 0px 10px 0px",
        "font-size": "1.5rem",
        "line-height": "2rem"
      },
      "strings": []
    },
    "descriptionsStyleProps": {
      "padding": "10px 0px 10px 0px",
      "text-align": "center",
      "margin": "0px 0px 0px 0px"
    },
    "descriptionsStylePropsTab": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptionsStylePropsMob": {
      "padding": "10px 0px 10px 0px"
    },
    "descriptions": [],
    "buttonsStyleProps": {
      "margin": "50px 0px 0px 0px"
    },
    "buttonAlign": "start",
    "buttons": [
      {
        "styleProps": {
          "padding": "10px 40px 10px 40px",
          "border-width": "0px",
          "color": "#333333",
          "background-color": "#c6dcff",
          "border-radius": "9999px"
        },
        "alt": "Google Play Store",
        "href": "#",
        "text": "Join",
        "openType": "sametab"
      },
      {
        "styleProps": {
          "padding": "10px 40px 10px 40px",
          "color": "#333333",
          "background-color": "#ffffff",
          "border-width": "1px",
          "border-color": "#808080",
          "border-radius": "9999px"
        },
        "alt": "Apple App Store",
        "href": "#",
        "text": "Learn More",
        "openType": "sametab"
      }
    ],
    "emailSecStyleProps": {},
    "subscription": {
      "showSection": "hide",
      "display": "enable",
      "subConfigs": {
        "configType": "convertkit",
        "configUrl": "https://app.convertkit.com/forms/xxxxxx/subscriptions",
        "configPlaceholder": ""
      },
      "email_placeholder": {
        "text": "example@mail.com"
      },
      "buttonText": {
        "text": "Subscribe",
        "styleProps": {
          "background-color": "#1b1b31",
          "color": "#ffffff"
        }
      },
      "successMessage": {
        "text": "Thank you for the signup",
        "styleProps": {}
      },
      "errorMessage": {
        "text": "Something went wrong. Please try again.",
        "styleProps": {}
      }
    }
  },
  "imageType": "image",
  "imageVideoPostion": "right",
  "imageBlock": {
    "image": "https://images.pexels.com/photos/1181406/pexels-photo-1181406.jpeg?auto=compress&cs=tinysrgb&w=600",
    "styleProps": {
      "margin": "20px 20px 20px 20px"
    }
  },
  "videoBlock": {
    "url": "https://www.youtube.com/watch?v=tKR58TIaJ9k",
    "styleProps": {
      "margin": "20px 20px 20px 20px"
    },
    "videoHeight": {
      "height": "400px"
    }
  },
  "htmlBlock": {
    "value": "",
    "styleProps": {}
  },
  "metaDataId": 1745671700151,
  "afterIndex": 0,
  "blockId": 1745671700151,
  "buttons": [
    {
      "text": "Click Here",
      "styleProps": {
        "color": "#ffffff",
        "border-color": "#3b82f680"
      },
      "href": "#",
      "openType": "sametab"
    }
  ],
  "fonts": {
    "textBlock": "Source Serif 4"
  },
  "position": "hide",
  "stylePropsTab": {
    "padding": "80px 20px 80px 20px"
  },
  "stylePropsMob": {
    "padding": "60px 20px 60px 20px"
  }
}